module.exports = __webpack_public_path__ + "static/media/Poppins-Regular.8081832f.ttf";